import { CurrencyPipe } from "@angular/common";
import { Component, input, Input, OnInit } from "@angular/core";
import { MilestoneCardData, CardMetadata, CARD_METADATA } from "@shared/models/milestone-cards.interface";

@Component({
	selector: "app-milestone-cards",
	templateUrl: "./milestone-cards.component.html",
	styleUrls: ["./milestone-cards.component.scss"]
})
export class MilestoneCardsComponent implements OnInit {
	@Input() set datasource(data: MilestoneCardData[]) {
		this._datasource = data;
		this.getMilestoneCardStatus(data);
	}

	isCPNowDeductionsEnabled = input(false);

	_datasource: MilestoneCardData[] = [];
	cardMeta!: CardMetadata;

	milestoneCardStatus: string = "";

	constructor(private currencyPipe: CurrencyPipe) {}

	ngOnInit() {}

	getMetadata(key: string): CardMetadata {
		return (
			CARD_METADATA[key] ?? {
				header: key,
				icon: "info",
				iconClass: "icon-default",
				type: "custom"
			}
		);
	}

	getIcon(key: string): string {
		return this.getMetadata(key).icon;
	}

	getIconClass(key: string): string {
		return this.getMetadata(key).iconClass;
	}

	getHeader(key: string): string {
		return this.getMetadata(key).header;
	}

	getFormattedText(cardData: MilestoneCardData): string {
		const type = this.getMetadata(cardData.key).type;

		switch (type) {
			case "headcount":
				return `${cardData.value} Employee${cardData.value != 1 ? "s" : ""}`;
			case "currency":
				return cardData.value !== null
					? `${this.currencyPipe.transform(cardData.value, cardData.currencyCode, "symbol", "1.2-2")}`
					: this.hasG2NError(
							cardData,
							`${this.currencyPipe.transform(0, cardData.currencyCode, "symbol", "1.2-2")}`
					  );
			default:
				return String(cardData.value);
		}
	}
	/**
	 * Remove value and display only currency code
	 * Format null Payroll value (G2N error)
	 */
	hasG2NError(cardData: MilestoneCardData, cardValue: string | number): string {
		return cardData.key === "totalPayroll" && this.milestoneCardStatus === "g2nError"
			? `-${cardValue.toString().replace(/0.00/g, "")}`
			: cardValue.toString();
	}

	/**
	 * @param key: Net payment order card key
	 * @returns class to use for value color
	 */
	getCardValueColor(key: string): string {
		switch (key) {
			case "totalAmount":
				return this.milestoneCardStatus === "success"
					? "complete"
					: this.milestoneCardStatus === "handshakeError"
					? "error"
					: "default";
			case "totalPayroll":
				return this.milestoneCardStatus === "g2nError" ? "error" : "default";
			default:
				return "default";
		}
	}

	/**
	 * check milestone card status
	 * @param cardData: milestone card data
	 */
	getMilestoneCardStatus(cardData: MilestoneCardData[]): void {
		if (cardData) {
			const wpayValue = cardData.find(card => card.key === "totalAmount")?.value;
			const payrollValue = cardData.find(card => card.key === "totalPayroll")?.value;
			const handshakeSucessful = !cardData.find(card => card.key === "totalPayroll");

			if (handshakeSucessful) {
				this.milestoneCardStatus = "success";
			} else if (wpayValue === null && payrollValue === null) {
				this.milestoneCardStatus = "default";
			} else if (wpayValue !== null && payrollValue === null) {
				this.milestoneCardStatus = "g2nError";
			} else if (wpayValue !== payrollValue) {
				this.milestoneCardStatus = "handshakeError";
			}
		}
	}
}
